﻿export class SalesForceClient {
    constructor(private e: any) {
    }

    public insert(model: any) {
        return this.e.callSfdc({
            operation: "insert",
            params: model
        }).then(resp => {
            if (resp.statusCode >= 200 && resp.statusCode < 400) {
                return JSON.parse(resp.body).id;
            }
            throw resp.body;
        });
    }

    public update(model: any) {
        return this.e.callSfdc({
            operation: "update",
            params: model
        }).then(resp => {
            if (resp.statusCode >= 200 && resp.statusCode < 400) {
                return model.Id;
            }
            throw resp.body;
        });
    }

    public delete(model: any) {
        return this.e.callSfdc({
            operation: "delete",
            params: model
        }).then(resp => {
            if (resp.statusCode >= 200 && resp.statusCode < 400) {
                return model.Id;
            }
            throw resp.body;
        });
    }

    public query(query: string) {
        return this.e.callSfdc({
            operation: "query",
            query
        }).then(resp => {
            if (resp.statusCode >= 200 && resp.statusCode < 400) {
                return JSON.parse(resp.body).records;
            }
            throw resp.body;
        });
    }

    public attachByTag(modelId: string, idQuote: number, idTag: number) {
        return this.e.attachFileToSfdc({
            source: 0,
            id: modelId,
            idQuote,
            idTag
        });
    }

    public attachMedia(modelId: string, mediaPath: string) {
        return this.e.attachFileToSfdc({
            source: 1,
            id: modelId,
            filePath: mediaPath
        });
    }

    public attachQuoteProduct(modelId: string, idQuote: number, idTag: number, idQuoteProduct: number) {
        return this.e.attachFileToSfdc({
            source: 2,
            id: modelId,
            idQuote,
            idTag,
            idQuoteProduct
        });
    }
}
